import { useRouter } from "next/router";
import { getRoute } from "@/services/config";
import MenuLayout from "@/components/common/MenuLayout";
import FeatureCard from "@/components/dashboard/FeatureCard";
import { FormIcon, InsightsIcon, GiftIcon } from "@/components/common/icons";
import PageHead from "@/components/common/PageHead";
import { isMaintenance } from "@/config/config";

export default function App() {
  const router = useRouter();

  return (
    <MenuLayout>
      <PageHead></PageHead>
      <div
        className={`grid grid-cols-1 sm:grid-cols-2 gap-6 pt-8 ${
          isMaintenance ? "sm:pt-10" : "sm:pt-[100px]"
        }  pb-10 px-5 sm:px-[7vw]`}
      >
        <FeatureCard
          name="Collect wallets"
          intro="Create a KARATForm to collect wallets so that you can view useful insights."
          btnText="Create form"
          Icon={FormIcon}
          onClick={() => {
            router.push(getRoute("form").route);
          }}
        ></FeatureCard>
        <FeatureCard
          name="Analyze wallets"
          intro="View informative wallet insights like ETH balance, blue chip NFTs, tags and social media accounts."
          btnText="Analyze wallets"
          Icon={InsightsIcon}
          onClick={() => {
            router.push(getRoute("analytics").route);
          }}
        ></FeatureCard>
        <FeatureCard
          name="Create airdrop"
          intro="Create a NFT or token airdrop through our launchpad and share it with your audience. This helps to increase your project’s engagement and visibility."
          btnText="Create airdrop"
          Icon={GiftIcon}
          onClick={() => {
            router.push(getRoute("airdrop").route);
          }}
        ></FeatureCard>
      </div>
    </MenuLayout>
  );
}
